import { Plugin_getInstance2t18sf8ddmzc5 as Plugin_getInstance } from './WebSockets.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../../request/HttpRequest.mjs';
import { HttpStatement3zxb33q8lku as HttpStatement } from '../../statement/HttpStatement.mjs';
import { DefaultClientWebSocketSession1n8ok3lng45wy as DefaultClientWebSocketSession } from './ClientSessions.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { close2zjubq94ny3dk as close } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { Key_instance1cfwgdmm6vbbh as Key_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { withContextqz5k6d9p9xx5 as withContext } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_useEngineDispatcher3ja9ea3m8f657 as get_useEngineDispatcher } from '../../statement/DispatcherSwitching.nonJvm.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Companion_getInstancehe53gw4v5mqu as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *webSocket(_this__u8e3s4, request, block, $completion) {
  plugin(_this__u8e3s4, Plugin_getInstance());
  // Inline function 'io.ktor.client.request.prepareRequest' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpRequestBuilder())();
  this_0.k5u(webSocket$lambda);
  request(this_0);
  // Inline function 'io.ktor.client.request.prepareRequest' call
  var session = new (HttpStatement())(this_0, _this__u8e3s4);
  $l$block: {
    // Inline function 'io.ktor.client.statement.HttpStatement.body' call
    $l$block_0: {
      // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
      try {
        var response = yield* session.n5u($completion);
        var callFailure = null;
        try {
          if (get_useEngineDispatcher()) {
            var tmp = ensureNotNull(response.cw().bd(Key_instance));
            yield* withContext(tmp, webSocket$slambda(response, block), $completion);
          } else {
            // Inline function 'io.ktor.client.call.body' call
            var tmp_0 = response.y5i();
            // Inline function 'io.ktor.util.reflect.typeInfo' call
            var tmp_1 = getKClass(DefaultClientWebSocketSession());
            // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
            var tmp_2;
            try {
              tmp_2 = createKType(getKClass(DefaultClientWebSocketSession()), arrayOf([]), false);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_3 = null;
              } else {
                throw $p;
              }
              tmp_2 = tmp_3;
            }
            var tmp$ret$9 = tmp_2;
            var tmp$ret$8 = new (TypeInfo())(tmp_1, tmp$ret$9);
            var tmp_4 = yield* tmp_0.v5i(tmp$ret$8, $completion);
            var result = tmp_4 instanceof DefaultClientWebSocketSession() ? tmp_4 : THROW_CCE();
            try {
              yield* block(result, $completion);
            }finally {
              yield* close(result, VOID, $completion);
              result.r5b().q1b();
            }
          }
          break $l$block;
        } catch ($p_0) {
          if ($p_0 instanceof Error) {
            var cause = $p_0;
            callFailure = cause;
            throw cause;
          } else {
            throw $p_0;
          }
        }
        finally {
          yield* session.o5u(response, callFailure, $completion);
        }
      } catch ($p_1) {
        if ($p_1 instanceof CancellationException()) {
          var cause_0 = $p_1;
          throw unwrapCancellationException(cause_0);
        } else {
          throw $p_1;
        }
      }
    }
  }
  return Unit_instance;
}
function webSocket$lambda($this$url, it) {
  $this$url.l56(Companion_getInstance().o56_1);
  return Unit_instance;
}
function webSocket$slambda($response, $block) {
  return constructCallableReference(function *($this$withContext, $completion) {
    // Inline function 'io.ktor.client.call.body' call
    var tmp = $response.y5i();
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(DefaultClientWebSocketSession());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(DefaultClientWebSocketSession()), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
    var tmp_3 = yield* tmp.v5i(tmp$ret$1, $completion);
    var result = tmp_3 instanceof DefaultClientWebSocketSession() ? tmp_3 : THROW_CCE();
    try {
      yield* $block(result, $completion);
    }finally {
      yield* close(result, VOID, $completion);
      result.r5b().q1b();
    }
    return Unit_instance;
  }, 1);
}
//region block: exports
export {
  webSocket as webSocketnufamvos0jph,
};
//endregion

//# sourceMappingURL=builders.mjs.map
